module.exports = __webpack_public_path__ + "media/assets/illustrations/happy-mom-b65aff983f44a17b500a6c206fae0b0d.png";